// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RKnX","colBig":"styles_colBig__1cRcE","colSmall":"styles_colSmall__3hNKl"};